var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#000000;stroke-width:1.5px;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-miterlimit:10;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,4.75h9a2,2,0,0,1,2,2v10.5a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V6.75A2,2,0,0,1,3,4.75Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 23.25,
    x2: 3.211,
    y2: 18.298
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14,
    y1: 23.25,
    x2: 11.789,
    y2: 18.298
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 7.75,
    x2: 14,
    y2: 7.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 12.25,
    x2: 14,
    y2: 12.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "0.5 23.25 23.5 23.25 23.5 4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5.75h2.936A3.064,3.064,0,0,1,23.5,3.814V4.75a0,0,0,0,1,0,0h-6a1,1,0,0,1-1-1v-2A1,1,0,0,1,17.5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,18.75h5.5a0,0,0,0,1,0,0v4.5a0,0,0,0,1,0,0H17a0,0,0,0,1,0,0v-3.5A1,1,0,0,1,18,18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.5,18.75h-3v-5a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 19,
    cy: 8.75,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.5,
    y1: 15.25,
    x2: 8.5,
    y2: 15.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationIcon);
export default __webpack_public_path__ + "static/media/stationIcon.288d72cfb05c5c0d77d4e8072151f35d.svg";
export { ForwardRef as ReactComponent };